import { plural } from 'pluralize';
import apiApp from '~/config/apiApp';

import errorHandler from '~/shared/errors/handler';
import dictionaryEntity from '~/shared/providers/utils/dictionaryEntity';

class UpdateApp {
  constructor() {
    this.apiApp = apiApp;
  }

  async update({ entityName = '', dataObj = {}, parser = null }) {
    try {
      const { data } = await this.apiApp
        .put(`/${plural(entityName).replace('_', '-')}`, { data: [dataObj] })
        .then(res => res.data);

      if (data[0].status !== 200) {
        throw data[0].error;
      }

      if (parser) return parser([{ ...data[entityName] }])[0];

      return data;
    } catch (error) {
      const errors = errorHandler({
        error,
        title: `Error ao atualizar um ${
          dictionaryEntity({
            entityName,
          }) || 'Dados'
        }`,
        local: 'BaseRepositoriesAppUpdate',
      });

      throw errors;
    }
  }
}

export default UpdateApp;
